module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp2_4.eaff74a2.png";